import { makeStyles } from '@mui/styles';
import { Card, Typography, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Hidden from '@mui/material/Hidden';
import HelperIcon from 'src/shared/components/HelperIcon';
import { removeBlankSpaces } from 'src/shared/utils/string';

const useStyles = makeStyles(theme => ({
  helpWrapper: {
    padding: '32px 16px',
    [theme.breakpoints.up('md')]: {
      height: '100%'
    }
  },
  element: {
    cursor: 'pointer',
    display: 'block'
  },
  topIcon: {
    color: theme.palette.colorPalette[1],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  icon: {
    display: 'block',
    margin: '0 auto 12px auto'
  },
  iconWrapper: {
    background: theme.palette.icon,
    borderRadius: '50%',
    width: '70px',
    height: '70px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0 auto'
  },
  iconRoot: {
    width: '32px',
    height: '32px',
    fill: '#fff'
  },
  helpText: {
    textAlign: 'center',
    fontWeight: '500',
    color: theme.palette.text.primary,
    wordBreak: 'break-all',
    fontSize: '16px',
    marginTop: theme.spacing(2)
  },
  helpTitle: {
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '20px',
    margin: '0 8px'
  },
  helpDataRoot: {
    height: '100%',
    width: '100%'
  },
  helpContentRoot: {
    height: '100%'
  },
  headerWrapperRoot: {
    height: '20%'
  },
  iconsWrapperRoot: {
    height: '80%',
    alignContent: 'center'
  },
  helperWrapperInnerRoot: {
    [theme.breakpoints.up('md')]: {
      height: '100%'
    }
  },
  headerInnerBoxRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  iconWrapperRoot: {
    padding: '32px 0 0',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: '32px 0'
    }
  }
}));

const HelpBar = ({ helpBarData }) => {
  const classes = useStyles();
  const { t } = useTranslation(['common']);

  return (
    <Card className={classes.helpWrapper} spacing={4}>
      <Grid container item classes={{ root: classes.helperWrapperInnerRoot }}>
        <Grid className={classes.helpDataRoot} container item xs={12}>
          <Grid container item xs={12} classes={{ root: classes.headerWrapperRoot }}>
            <Hidden mdDown>
              <Grid item xs={12} className={classes.topIcon}>
                <HelperIcon size={40} hasAction={false} />
              </Grid>
            </Hidden>
            <Grid item xs={12} classes={{ root: classes.headerInnerBoxRoot }}>
              <Hidden mdUp>
                <div className={classes.topIcon}>
                  <HelperIcon size={40} hasAction={false} />
                </div>
              </Hidden>
              <Typography className={classes.helpTitle} component="h3" variant="h3">
                {t('Need help?')}
              </Typography>
            </Grid>
          </Grid>
          <Grid container item classes={{ root: classes.iconsWrapperRoot }}>
            {helpBarData?.map(
              ({ title, Icon, link }, index, array) =>
                title &&
                link && (
                  <Grid key={title} item xs={12} classes={{ root: classes.iconWrapperRoot }}>
                    <a href={removeBlankSpaces(link)} target="__blank">
                      <div className={classes.iconWrapper}>
                        <Icon classes={{ root: classes.iconRoot }} />
                      </div>
                      <Typography className={classes.helpText} component="h4" gutterBottom variant="h4">
                        {title}
                      </Typography>
                    </a>
                  </Grid>
                )
            )}
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
};

HelpBar.propTypes = {
  helpBarData: PropTypes.array
};

export default HelpBar;
